import { editorContentShiftViewState } from "../..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateActivityInfoCalloutVisible", function updateActivityInfoCalloutVisible(isVisible: boolean) {
    editorContentShiftViewState().activityInfoCalloutVisible = isVisible;
});
